import * as Utils from 'Assets/Utils'

import Immutable from 'immutable'
import ClientHttpRequest from "Api/ClientHttpRequest"
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
	.set('Get', new  Immutable.Map({}))
	.set('Info', new Immutable.Map({}))
	.set('Path', new Immutable.Map({path: ""}))

/* Types */
export const ACTION_GET_VARIABLE = 'ACTION_GET_VARIABLE'

export const ACTION_GET_GENERAL_INFO = 'ACTION_GET_GENERAL_INFO'

export const ACTION_SET_PATH = 'ACTION_SET_PATH'
/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_GET_VARIABLE:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_GET_GENERAL_INFO:
			return state.set('Info', new Immutable.Map(action.Obj))
		case ACTION_SET_PATH:
			return state.set('Path', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */
export const getEvaluationVariable = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getEvaluationVariable',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_VARIABLE, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setEvaluationVariable = (form) => {

	let idEvaluacion = form.idEvaluacion
	delete form.idEvaluacion

	let data = Object.assign({idEvaluacion, usuario: sessionStorage.uid}, form)

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setEvaluationVariable',
			method: "POST",
			data: { ...data },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			if(error.response.data.message && error.response.data.message === 'Error de conectividad')
				return;
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

/* Action Creators */
export const getEvaluationVariableInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getEvaluationVariableInfo',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch({ type: ACTION_GET_GENERAL_INFO, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setEvaluationVariableInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setEvaluationVariableInfo',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearEvaluationVariable = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_VARIABLE, Obj: {} })
		dispatch({ type: ACTION_GET_GENERAL_INFO, Obj: {} })
	}
}

export const setPath = (path) => {
	return (dispatch) => {
		dispatch({ type: ACTION_SET_PATH, Obj: {path} })
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Evaluation/Variable.js